import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { ThemeProvider } from 'react-css-themr';
import { Button, FontIcon, List, ListItem } from 'react-toolbox';
import EstimatorAPButton from '../EstimatorAPButton';
import { Link } from 'react-router';
import buttonStyles from './profileMenu.scss';
import { linkTo } from 'helpers/url';
import ToggleContrast from './toggleContrast';
import { roleNotInstallerBased } from '../../../utils';
import { can } from '../../../services/ability';

const theme = { RTButton: buttonStyles };

export default class ProfileMenu extends Component {
  static propTypes = {
    user: PropTypes.shape({
      id: PropTypes.number,
      name: PropTypes.string,
      employable_id: PropTypes.number,
      employable_type: PropTypes.string,
      msal: PropTypes.object,
    }),
    logoutUser: PropTypes.func,
  }

  constructor(props) {
    super(props);
    this.state = { canSendEmail: true, sendEmailButtonStyle: null };
  }

  setCanSendEmailToFalse = () =>
    this.setState({ canSendEmail: false, sendEmailButtonStyle: buttonStyles.disableSendEmailBtn })

  setCanSendEmailToTrue = () => this.setState({ canSendEmail: true, sendEmailButtonStyle: null });

  logout = () => {
    const { user: { msal = null } } = this.props;
    if (msal) msal.logout();
    this.props.logoutUser();
  }

  render = () => {
    const { user, user: { employable_type, employable_id, name, role } } = this.props;
    const profileUrl = (<Link
      to={linkTo({
        kind: employable_type,
        id: employable_id,
      })}
    >My Profile</Link>);
    return (<ThemeProvider theme={theme}>
      <div className={theme.RTButton.wrapper}>
        <Button inverse>
          {name}
          <FontIcon>keyboard_arrow_down</FontIcon>
        </Button>
        <div className={theme.RTButton.menu}>
          <List selectable className={theme.RTButton.listWrapper}>
            {roleNotInstallerBased(role, true) && <ListItem
              key="profile"
              value="profile"
              itemContent={profileUrl}
            />}
            {role === 'estimator' && can(role, 'manage', 'send_email') && <EstimatorAPButton
              user={user}
              canSendEmail={this.state.canSendEmail}
              setCanSendEmailToFalse={this.setCanSendEmailToFalse}
              setCanSendEmailToTrue={this.setCanSendEmailToTrue}
              className={this.state.sendEmailButtonStyle}
            />}
            <ListItem
              key="signout"
              value="signout"
              itemContent={<div>Sign Out</div>}
              onClick={this.logout}
            />
            <ListItem
              key="contrast"
              value="contrast"
              itemContent={<ToggleContrast />}
              ripple={false}
              selectable={false}
            />
          </List>
        </div>
      </div>
    </ThemeProvider>);
  }
}



// WEBPACK FOOTER //
// ./client/app/shared/components/NavigationBar/profileMenu.jsx